export const STATES = [
  { label: 'AL', value: 'AL' },
  { label: 'AK', value: 'AK' },
  { label: 'AZ', value: 'AZ' },
  { label: 'AR', value: 'AR' },
  { label: 'CA', value: 'CA' },
  { label: 'CO', value: 'CO' },
  { label: 'CT', value: 'CT' },
  { label: 'DE', value: 'DE' },
  { label: 'DC', value: 'DC' },
  { label: 'FL', value: 'FL' },
  { label: 'GA', value: 'GA' },
  { label: 'HI', value: 'HI' },
  { label: 'ID', value: 'ID' },
  { label: 'IL', value: 'IL' },
  { label: 'IN', value: 'IN' },
  { label: 'IA', value: 'IA' },
  { label: 'KS', value: 'KS' },
  { label: 'KY', value: 'KY' },
  { label: 'LA', value: 'LA' },
  { label: 'ME', value: 'ME' },
  { label: 'MD', value: 'MD' },
  { label: 'MA', value: 'MA' },
  { label: 'MI', value: 'MI' },
  { label: 'MN', value: 'MN' },
  { label: 'MS', value: 'MS' },
  { label: 'MO', value: 'MO' },
  { label: 'MT', value: 'MT' },
  { label: 'NE', value: 'NE' },
  { label: 'NV', value: 'NV' },
  { label: 'NH', value: 'NH' },
  { label: 'NJ', value: 'NJ' },
  { label: 'NM', value: 'NM' },
  { label: 'NY', value: 'NY' },
  { label: 'NC', value: 'NC' },
  { label: 'ND', value: 'ND' },
  { label: 'OH', value: 'OH' },
  { label: 'OK', value: 'OK' },
  { label: 'OR', value: 'OR' },
  { label: 'PA', value: 'PA' },
  { label: 'RI', value: 'RI' },
  { label: 'SC', value: 'SC' },
  { label: 'SD', value: 'SD' },
  { label: 'TN', value: 'TN' },
  { label: 'TX', value: 'TX' },
  { label: 'UT', value: 'UT' },
  { label: 'VT', value: 'VT' },
  { label: 'VA', value: 'VA' },
  { label: 'WA', value: 'WA' },
  { label: 'WV', value: 'WV' },
  { label: 'WI', value: 'WI' },
  { label: 'WY', value: 'WY' },
];

export const HEALTH_CLASSES = [
  { label: 'Preferred Plus', value: 'Preferred Plus' },
  { label: 'Preferred', value: 'Preferred' },
  { label: 'Standard Plus', value: 'Standard Plus' },
  { label: 'Standard', value: 'Standard' },
  { label: 'Table 1', value: 'Table 1' },
  { label: 'Table 2', value: 'Table 2' },
  { label: 'Table 3', value: 'Table 3' },
  { label: 'Table 4', value: 'Table 4' },
  { label: 'Table 5', value: 'Table 5' },
  { label: 'Table 6', value: 'Table 6' },
  { label: 'Table 7', value: 'Table 7' },
  { label: 'Table 8', value: 'Table 8' },
  { label: 'Table 9', value: 'Table 9' },
];

export const TERM_LENGTHS = [
  { label: '5 years', value: '5' },
  { label: '10 years', value: '10' },
  { label: '15 years', value: '15' },
  { label: '20 years', value: '20' },
  { label: '25 years', value: '25' },
  { label: '30 years', value: '30' },
  { label: '35 years', value: '35' },
  { label: '40 years', value: '40' },
];

export const PAYMENT_MODES = [
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Annual', value: 'Annual' },
];

export const COVERAGE_AMOUNT_MIN = 5000;
export const COVERAGE_AMOUNT_MAX = 10000000;
export const COVERAGE_ERROR_OVERRIDE = 'Must be between $5k and $10m';
